import { render } from "./EventSmallBox.vue?vue&type=template&id=3caaf1fa&scoped=true"
import script from "./EventSmallBox.vue?vue&type=script&lang=js"
export * from "./EventSmallBox.vue?vue&type=script&lang=js"

import "./EventSmallBox.vue?vue&type=style&index=0&id=3caaf1fa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3caaf1fa"

export default script